import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SalesPage } from './pages/SalesPage';
import { ReviewPage } from './pages/ReviewPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3ka4bd2zaadjv">
      <Routes data-id="element-1" data-mp="3k8jiriwj54on">
        <Route path="/" element={<SalesPage data-id="element-3" data-mp="3k7i3114kju0l" />} data-id="element-2" data-mp="3k92p02cti4mu" />
        <Route path="/revision" element={<ReviewPage data-id="element-5" data-mp="3fbjcp7zok1xj" />} data-id="element-4" data-mp="3fargbuy9e067" />
        <Route path="*" element={<SalesPage data-id="element-7" data-mp="3f8n9p58z6n28" />} data-id="element-6" data-mp="3fb9if87lr8m1" />
      </Routes>
    </BrowserRouter>;
}